import React from 'react'
import {
  // BooleanField,
  Datagrid,
  TextField,
  TextInput,
  // SearchInput,
  // SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, CONTACT_US_FIELDS } from '../../providers/localization/constant'

const ContactUsListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${NEWS_FIELDS}.title`)}
    // />,
    <TextInput key={0} source='subject' label={translate(`${CONTACT_US_FIELDS}.subject`)} />,
    <TextInput key={1} source='full_name' label={translate(`${CONTACT_US_FIELDS}.full_name`)} />,
    <TextInput key={2} source='email' label={translate(`${CONTACT_US_FIELDS}.email`)} />,
    <TextInput key={3} source='phone' label={translate(`${CONTACT_US_FIELDS}.phone`)} />,
  ]
}

const ContactUsList = (): JSX.Element => {
  return (
    <ListBase
      listAction={{
        hasCreate: false,
        hasExport: false,
      }}
      filters={ContactUsListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='show'>
        <TextField source='subject' label={`${CONTACT_US_FIELDS}.subject`}></TextField>
        <TextField source='message' label={`${CONTACT_US_FIELDS}.message`} sortable={false}></TextField>
        <TextField source='full_name' label={`${CONTACT_US_FIELDS}.full_name`} sortable={false}></TextField>
        <TextField source='email' label={`${CONTACT_US_FIELDS}.email`} sortable={false}></TextField>
        <TextField source='phone' label={`${CONTACT_US_FIELDS}.phone`} sortable={false}></TextField>
        <TextField source='line_id' label={`${CONTACT_US_FIELDS}.line_id`} sortable={false}></TextField>
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        {/* <BooleanField
          source='is_accept'
          label={`${CONTACT_US_FIELDS}.accept`}
          textAlign='center'
          sortable={false}
        /> */}
        {/* <BooleanField
          source='is_published'
          label={`${COMMON_FIELDS}.published.label`}
          textAlign='center'
          sortable={false}
        /> */}
      </Datagrid>
    </ListBase>
  )
}

export default ContactUsList
